import Konva from 'konva';
import { clamp } from 'lodash-es';
import { QUESTIONS_DEF } from '../constants/questions_def';
import { calculateEmissions } from './emissions';
export const drawPortrait = (portraitContainer, userAnswersList, { width: canvasWidth }) => {
    const stage = new Konva.Stage({
        container: portraitContainer,
        width: canvasWidth,
        height: canvasWidth,
    });
    const backgroundLayer = new Konva.Layer();
    const layer = new Konva.Layer();
    const stageBackground = new Konva.Rect({
        width: canvasWidth,
        height: canvasWidth,
        fill: '#414141',
    });
    backgroundLayer.add(stageBackground);
    stage.add(backgroundLayer);
    stage.add(layer);
    const answersWithDataPortrait = userAnswersList.flatMap((answerList) => answerList.filter((answer) => Boolean(answer.dataPortrait)));
    answersWithDataPortrait.forEach((answer) => {
        const { tag, fill, d, radius, height, reuseElement } = answer.dataPortrait;
        switch (tag) {
            case 'path':
                const path = new Konva.Path({
                    data: d,
                    fill: fill,
                    stroke: 'transparent',
                    y: canvasWidth / 2 - height * (canvasWidth / 75),
                    scaleX: canvasWidth / 75,
                    scaleY: canvasWidth / 75,
                });
                layer.add(path);
                path.moveDown();
                path.moveDown();
                break;
            case 'circle':
                if (reuseElement) {
                    const elementsToBeFused = answersWithDataPortrait
                        .map((a) => a.dataPortrait)
                        .filter(Boolean)
                        .filter((dp) => dp.reuseElement === reuseElement);
                    const { fill, radius } = Object.assign({}, ...elementsToBeFused);
                    let circle = new Konva.Circle({
                        fill: fill,
                        x: canvasWidth / 2,
                        y: canvasWidth / 2,
                        radius: radius,
                        opacity: 0.9,
                        scaleX: canvasWidth / 75,
                        scaleY: canvasWidth / 75,
                    });
                    layer.add(circle);
                }
                else {
                    let circle = new Konva.Circle({
                        fill: fill,
                        x: canvasWidth / 2,
                        y: canvasWidth / 2,
                        radius: radius,
                        opacity: 0.9,
                        scaleX: canvasWidth / 75,
                        scaleY: canvasWidth / 75,
                    });
                    layer.add(circle);
                }
                break;
            case 'rect':
                const rect = new Konva.Rect({
                    width: canvasWidth,
                    height: canvasWidth,
                    fill: fill,
                });
                layer.add(rect);
                rect.moveToBottom();
                break;
            case 'texture':
                const emissions = calculateEmissions(userAnswersList);
                const texture = new Konva.Rect({
                    width: canvasWidth,
                    height: canvasWidth / 2,
                    x: 0,
                    y: canvasWidth / 2,
                    opacity: clamp((emissions * 6) / 100, 0, 1),
                });
                let imageObj = new Image();
                imageObj.onload = function () {
                    texture.fillPatternImage(imageObj);
                };
                imageObj.onerror = function () {
                    console.error('Error loading image for pattern');
                };
                imageObj.src = '/img/texture.png';
                layer.add(texture);
                const currentQuestion = QUESTIONS_DEF.find((question) => question.id === answer.questionId);
                const greenIds = [
                    'reason_means_of_transport_bike_or_walk',
                    'reason_means_of_transport_train_or_bus',
                ];
                if (greenIds.includes(currentQuestion.previousQuestionId(userAnswersList))) {
                    const path = new Konva.Path({
                        data: 'M0 34H0.656681C4.89862 33.6292 9.64816 26.3025 12.5 22.5001C27 -1.00005 33.2994 0.187996 38 0C50 -0.000162047 58 14.9998 63 22C70.5 32.9998 73.3333 33.6667 75 34H0.656681C0.436305 34.0193 0.217299 34.0197 0 34Z',
                        fill: 'white',
                        stroke: 'transparent',
                        y: canvasWidth / 2 - 34 * (canvasWidth / 75),
                        scaleX: canvasWidth / 75,
                        scaleY: canvasWidth / 75,
                    });
                    layer.add(path);
                    path.moveDown();
                    path.moveDown();
                }
                break;
        }
    });
    layer.draw();
    return stage;
};
export const getAnswersToBeDrawn = (surveyStatus) => {
    const { currentUserAnswer, userAnswersList, currentQuestionId } = surveyStatus;
    const filteredUserAnswersList = userAnswersList.filter((answer) => !answer[0].isOldAnswer);
    return currentUserAnswer.length > 0 || currentQuestionId === 'suggestions'
        ? [...filteredUserAnswersList, currentUserAnswer]
        : filteredUserAnswersList;
};
